import React, { useEffect, useState } from 'react';
import { INavigationItemProps } from '../NavigationItem';
import styled from 'styled-components';
import { HeaderShadowWrapper } from '../../HeaderShadowWrapper/HeaderShadowWrapper';
import { FlexRow } from '../../FlexRow/FlexRow';
import { SpaceWrapper } from '../../SpaceWrapper/SpaceWrapper';
import { SubNavigation } from '..';
import ReactDOM from 'react-dom';
import { ReactNode } from 'react';
import { useHasFeatureFlag } from '../../../../selectors/useHasFeatureFlag';

export interface IMiniNavigationProps {
  active?: string;
  primary?: string | ReactNode;
  children?: React.ReactElement<INavigationItemProps>[];
  navigationReplacement?: ReactNode;
  secondary?: string | ReactNode;
  when: number;
}

interface IMiniNavigationBarProps {
  isVisible: boolean;
}

const PrimarySection = styled.div`
  padding: ${(props) => props.theme.spacing.spacing4};
  ${(props) => props.theme.fonts.mixins.boldSmall}
`;
const SecondarySection = styled.div`
  padding: ${(props) => props.theme.spacing.spacing4};
  ${(props) => props.theme.fonts.mixins.small}
`;
const MiniNavigationBar = styled.div<IMiniNavigationBarProps>`
  display: ${(props) => (props.isVisible ? 'block' : 'none')};
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
`;

export const MiniNavigation: React.FunctionComponent<IMiniNavigationProps> = ({
  children,
  navigationReplacement,
  primary,
  secondary,
  active,
  when,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > when) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [when]);
  const isZillowClosingEnabled = useHasFeatureFlag('pinecone.zillow-closing');

  return ReactDOM.createPortal(
    <MiniNavigationBar isVisible={isVisible}>
      <HeaderShadowWrapper useDefaultBackground={isZillowClosingEnabled}>
        <SpaceWrapper topSpace={'default'} rightSpace={'roomy'} leftSpace={'roomy'} bottomSpace={'none'}>
          <FlexRow justifyContent={'space-between'}>
            <FlexRow verticalAlign={'center'}>
              <PrimarySection>{primary}</PrimarySection>
            </FlexRow>
            <FlexRow verticalAlign={'center'}>
              <SecondarySection>{secondary}</SecondarySection>
            </FlexRow>
          </FlexRow>
          {navigationReplacement || <SubNavigation active={active}>{children}</SubNavigation>}
        </SpaceWrapper>
      </HeaderShadowWrapper>
    </MiniNavigationBar>,
    document.body
  );
};
